<template>
  <div class="pt-2 main-component-wrapper" :style="userStyle">
    <div v-if="pageNotFoundError === false && isLoadApiColor">
      <div class="row mx-0">
        <div class="col-12">
          <div class="top-nav">
            <img width="24" :src="setting.image" alt="" />
            <p>{{ setting.title }}</p>
          </div>
        </div>
      </div>
      <div class="row mt-3 mx-0" id="welcome-video-wrapper" v-bind:class="{ 'd-none': !setting.display_welcome_video ||  setting.welcome_video_processing_status != 'completed' }">
        <div class="col-12">
          <div class="intro-video align-content-center">
            <div class="">
              <div class="video-inner-container">
                <video ref="videoPlayer" id="videoPlayer" class="video-js vjs-fluid vjs-big-play-centered"></video>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mx-0" v-if="setting.welcome_video_processing_status && setting.welcome_video_processing_status != 'completed'">
        <div class="col-12">
          <div class="video-spin-loader">
            <div class="inner-loader">
              <img width="70" src="../assets/spin-loader.svg" alt="" class="img-fluid" />
              <div>Processing Video</div>
            </div>
          </div>
        </div>
      </div>
      <UserPeronalizedMessage :setting="setting"></UserPeronalizedMessage>
      <UserProfile :setting="setting"></UserProfile>
      <div class="row mt-3 mx-0" v-if="isRewardEnabled">
        <div class="col-12">
          <div class="progile-reward">
            <div class="image">
              <img src="../assets/confetti.svg" alt="" class="img-fluid" />
            </div>
            <div class="text">
              <p class="title">
                You can unlock exclusive rewards!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mx-0" v-if="setting.enabled_expired_at === 1">
        <div class="col-12">
          <count-down :date="setting.expired_at"></count-down>
        </div>
      </div>
      <div class="footer-panel">
        <a @click="continueToFeedback" class="btn action-btn" v-bind:disabled="loading">
          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
          <svg v-if="!loading" width="24" height="24" viewBox="0 0 24 24" fill="" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.58984 16.34L13.1698 11.75L8.58984 7.16L9.99984 5.75L15.9998 11.75L9.99984 17.75L8.58984 16.34Z" fill="" />
          </svg>
          Continue
        </a>
        <Branding></Branding>
      </div>
    </div>
    <div v-if="pageNotFoundError == true">
      <PageNotFound></PageNotFound>
    </div>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";
import axios from "axios";
import CountDown from "./CountDown";
import videojs from "video.js";
import PageNotFound from "./PageNotFound";
import Branding from "./partials/branding.vue";
import UserProfile from "./partials/userProfile.vue";
import UserPeronalizedMessage from "./partials/UserPeronalizedMessage.vue";
import Vue from "vue";

export default {
  name: "Profile",
  component: {
    PageNotFound,
  },
  props: {
    msg: String,
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      uuid: uuid.v1(),
      setting: {},
      response: {},
      src: "",
      pageNotFoundError: false,
      baseUrl: "",
      uniqueId: "",
      pixelKey: "",
      player: null,
      background_color: "",
      accent_color: "",
      isLoadApiColor: false,
      isRewardEnabled: false,
      kitData: {},
      screenIndexs: [],
      encryptKey: null,
      loading:false
    };
  },
  components: {
    PageNotFound,
    CountDown,
    Branding,
    UserProfile,
    UserPeronalizedMessage,
    // VideoJS
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  created() {
    if (this.$route.query.url) {
      this.$session.set("baseUrl", this.$route.query.url);
    }
    if (this.$route.query.unique_id) {
      this.$session.set("unique_id", this.$route.query.unique_id);
    }
    if (this.$route.query.pixel_key) {
      Vue.prototype.$pixel_key = this.$route.query.pixel_key;
      this.$session.set("pixel_key", this.$route.query.pixel_key);
    }
    if (this.$route.query.encrypt_key) {
      Vue.prototype.$encrypt_key = this.$route.query.encrypt_key;
      this.$session.set("encrypt_key", this.$route.query.encrypt_key);
    }
    this.baseUrl = this.$session.get("baseUrl");
    this.uniqueId = this.$session.get("unique_id");
    this.pixelKey = this.$session.get("pixel_key");
    this.encryptKey = this.$session.get("encrypt_key");
    Vue.prototype.$currentScreenIndex = 0;
    if (this.encryptKey) {
      Vue.prototype.$fromAdminSide = true;
    } else {
      Vue.prototype.$fromAdminSide = false;
    }
    if (this.baseUrl) {
      this.$session.set("baseUrl", this.baseUrl);
    }
    if (this.uniqueId) {
      this.$session.set("uniqueId", this.uniqueId);
    }
    if (this.pixelKey) {
      this.$session.set("pixelKey", this.pixelKey);
    }
    if (this.$fromAdminSide) {
      if (this.$session.get("response") && !this.$route.query.url) {
        let response = this.$session.get("response");
        this.initilizeProfile(response);
      } else {
        this.loadData();
      }
    } else {
      this.loadData();
    }
  },
  methods: {
    initilize_welcome_video_player(srcVideo) {
      try {
        this.player = videojs(document.getElementById("videoPlayer"), {
          controls: true,
          autoplay: false,
          preload: "none",
          poster: this.setting.welcome_video_poster,
          liveui: true,
        });
        this.player.ready(function() {
          this.src({
            src: srcVideo,
            type: "video/mp4",
          });
          this.tech(false);
        });
      } catch (e) {
        console.log(e);
      }
    },
    checkRewardEnabledOrNot() {
      if (this.response && this.response.options) {
        let found = false;
        this.response.options.forEach((element) => {
          if (element.is_offer_reward || element.is_offer_reward == "1") {
            this.isRewardEnabled = true;
            found = true;
            return;
          }
        });
        if (!found) {
          this.isRewardEnabled = false;
        }
      } else {
        this.isRewardEnabled = false;
      }
    },
    loadData() {
      let url = this.baseUrl + "api/kit/" + this.uniqueId + "?token=f2580909804d96e9410a9c6298a0f73b7&encrypt_key=" + this.encryptKey;
      // DEBUG The Kit
      // let url = "https://app.vouchkick.com/api/kit/vk-demo-555?token=f2580909804d96e9410a9c6298a0f73b7&encrypt_key=undefined"
      axios
        .get(url)
        .then((response) => {
          // console.log(response);
          this.initilizeProfile(response.data.response);
        })
        .catch(() => {
          this.pageNotFoundError = true;
        });
    },
    initilizeProfile(response) {
      // console.log(response)
      this.$session.start();
      this.$session.set("uuid", this.uuid);
      this.$session.set("response", response);
      this.$session.set("kitData", response);
      this.kitData = response;
      if (this.$fromAdminSide) {
        this.screenIndexs = this.$helpers.makeScreensInxes(this.kitData);
      }
      this.response = response;
      this.src = this.response.settings.welcome_video;
      this.background = response.settings.background_color;
      this.accent_color = response.settings.accent_color;
      setTimeout(() => {
        this.$helpers.updateColorAccordingApi();
        this.isLoadApiColor = true;
        var srcVideo = this.src;
        this.setting = response.settings;
        global.event.$emit("display_close_button", this.response.settings.display_close_button);
        this.checkRewardEnabledOrNot();
        setTimeout(() => {
          this.initilize_welcome_video_player(srcVideo);
        }, 100);
      }, 50);
    },
    continueToFeedback() {
      if (!this.$fromAdminSide) {
        this.$router.push("/feedback");
      }
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            let color_change = false;
            console.log(event.data.settings)
            // console.log(event.data.settings);
            for (let key in event.data.settings) {
              if (key == "welcome_video") {
                let selected_video = URL.createObjectURL(event.data.settings[key]);
                this.setting.welcome_video_processing_status = "completed";
                // console.log(selected_video)
                document.getElementById('welcome-video-wrapper').classList.remove('d-none');
                this.player.posterImage.hide();
                this.initilize_welcome_video_player(selected_video);
              } else {
                this.response.settings[key] = event.data.settings[key];
                this.setting[key] = event.data.settings[key];
                if (key.indexOf("_color")) {
                  color_change = true;
                  this[key] = event.data.settings[key];
                }
              }
            }
            this.$session.set("response", this.response);
            if (color_change) {
              this.$helpers.updateColorAccordingApi();
            }
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            // console.log(event.data.option);
            let option_request = event.data.option;
            if (option_request.remove_option) {
              let options = this.response.options.filter(function(e) {
                return e.feedback_option_id != option_request.remove_option;
              });
              this.response.options = options;
            } else {
              let found = false;
              if (this.response.options && this.response.options.length) {
                this.response.options.forEach((element, index) => {
                  if (element.feedback_option_id == option_request.option_id) {
                    found = true;
                    for (let key in option_request) {
                      // console.log(key);
                      if (typeof this.response.options[index][key] !== "undefined") {
                        this.response.options[index][key] = option_request[key];
                      }
                    }
                  }
                });
              }
              if (!found) {
                this.response.options.push(event.data.option);
              }
            }
            this.$session.set("response", this.response);
            this.screenIndexs = this.$helpers.makeScreensInxes(this.response);
            this.checkRewardEnabledOrNot();
          } else if (event.data.screenAction == "next") {
            if (this.screenIndexs.length) {
              this.$currentScreenIndex += 1;
              let currentScreen = this.screenIndexs[this.$currentScreenIndex];
              // console.log(currentScreen.screen , "NEXT");
              if (currentScreen) {
                // console.log(currentScreen.screen, "NEXT");
                if (currentScreen.screen == "launcherScreen") {
                  // console.log("send meesage to parent");
                  parent.postMessage({ launcherScreen: true }, "*");
                } else if (currentScreen.screen == "profile") {
                  // console.log("send meesage to parent");
                  parent.postMessage({ profileScreen: true }, "*");
                  // this.$router.push("/home");
                  //  //this.$forceUpdate();
                  // this.$router.go();
                } else if (currentScreen.screen == "feedback") {
                  this.$router.push("/feedback");
                } else if (currentScreen.screen == "questions" && currentScreen.data) {
                  this.$helpers.moveToSelectedOption(currentScreen.data.option_unique_id, currentScreen.data.option_question_id);
                } else if (currentScreen.screen == "collections") {
                  this.$router.push({ name: "OptionSubmit" });
                } else if (currentScreen.screen == "thanksPage") {
                  this.$router.push({ query: { thanksPage: true } });
                }
              } else {
                Vue.prototype.$currentScreenIndex = 0;
                this.$router.push({ name: "Home" });
                this.$forceUpdate();
                this.$router.go();
                console.log("send meesage to parent");
                parent.postMessage({ profileScreen: true }, "*");
              }
            }
          } else if (event.data.screenAction == "back") {
            if (this.screenIndexs.length) {
              this.$currentScreenIndex -= 1;
              if (this.$currentScreenIndex < 0) {
                this.$currentScreenIndex = this.screenIndexs.length - 1;
              }
              let currentScreen = this.screenIndexs[this.$currentScreenIndex];
              // console.log(currentScreen.screen , "BACK");
              if (currentScreen) {
                if (currentScreen.screen == "launcherScreen") {
                  parent.postMessage({ launcherScreen: true }, "*");
                  // this.$router.push({ name: "Home" });
                  // // this.$forceUpdate();
                  // this.$router.go();
                } else if (currentScreen.screen == "profile") {
                  // parent.postMessage({ profileScreen: true }, "*");
                  this.$router.push({ name: "Home" });
                  // // this.$forceUpdate();
                  this.$router.go();
                } else if (currentScreen.screen == "feedback") {
                  this.$router.push("/feedback");
                } else if (currentScreen.screen == "questions" && currentScreen.data) {
                  this.$helpers.moveToSelectedOption(currentScreen.data.option_unique_id, currentScreen.data.option_question_id);
                } else if (currentScreen.screen == "collections") {
                  this.$router.push({ name: "OptionSubmit", query: { thanksPage: false } });
                } else if (currentScreen.screen == "thanksPage") {
                  // this.$router.push({ query: { thanksPage: true } });
                  parent.postMessage({ profileScreen: true }, "*");
                  this.$router.push({ name: "OptionSubmit", params: { thanksPage: true } });
                }
              }
            }
          } else if (event.data.reset_session) {
            this.loadData();
          }
        }
      },
      false
    );
  },
  computed: {
    userStyle() {
      return {
        "--background-color": this.background_color,
        "--accent-color": this.accent_color,
      };
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.video-spin-loader {
  height: 200px;
  position: relative;
  opacity: 0.6;
  background: #f1f1f1;
  width: 100%;
  .inner-loader {
    position: absolute;
    top: 33%;
    left: 0;
    width: 100%;
  }
}
.fa-spinner{
margin-right: 8px;
}
.main-component-wrapper {
  background: var(--background-color);
}
.top-nav {
  background: var(--launcher-btn-background-color);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: var(--launcher-btn-color);
    margin: 0;
    margin-left: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    text-align: left;
  }
}
.profile {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 5px;
  padding: 10px 16px;
  .image {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
    margin-right: 17px;
  }
  .text {
    text-align: left;
    .title {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 22px;
      color: #313c4e;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
    .sub-title {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      color: #2b3648;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
  }
}
.progile-reward {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 5px;
  padding: 12px 12px;
  .image {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
    margin-right: 17px;
  }
  .text {
    text-align: left;
    .title {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 22px;
      color: #313c4e;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
  }
}
.intro-msg {
  padding: 8px 16px;
  background: #2aa6ff;
  border-radius: 15px 15px 15px 0px;
  p {
    font-family: "Mulish", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
    text-align: left;
  }
}
.intro-video {
  position: relative;
  .player-btn {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.confetti-msg {
  padding: 12px;
  background: #ffffff;
  border-radius: 5px;
  .icon {
    margin-right: 10px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.01em;
      color: #313c4e;
    }
  }
}
.timer {
  padding: 12px 14px 16px 12px;
  background: #ffffff;
  border-radius: 5px;
  .icon {
    margin-right: 44.5px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #313c4e;
    }

    .colon {
      padding: 4px 8px;
      p {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .day {
      .number {
        font-size: 24px;
        line-height: 36px;
      }
      .title {
        font-size: 11px;
        line-height: 16px;
        letter-spacing: -0.02em;
      }
    }
  }
}
.footer-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 16px;
  // background: #fff;
  margin-top: 18px;
  // box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.06);

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--accent-color);
    border-radius: 4px;
    color: var(--action-btn-color);
    max-width: 215px;
    width: 100%;
    padding: 12px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.24);
    font-family: "Poppins", sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.01em;
    svg {
      fill: var(--action-btn-color);
      margin-right: 8px;
    }
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.01em;
    }
  }

  .copyright {
    display: flex;
    align-items: flex-end;
    margin-top: 16px;
    .icon {
      margin-right: 4.84px;
      display: flex;
      align-items: flex-end;
      padding-bottom: 3px;
    }
    .text {
      p {
        font-family: "Mulish", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 15px;
        color: #8997b1;
      }
    }
  }
}
.videojs {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-inner-container {
  max-height: 278px;
  height: auto;
  width: auto;
  border-radius: 5px;
  min-height: 278px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .videoPlayer-dimensions.vjs-fluid {
    padding-top: 0;
  }
}
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: auto;
  max-width: 100%;
  height: 278px !important;
  border-radius: 5px;
  overflow: hidden;

  .vjs-tech {
    position: initial;
    // width: auto;  // Cut the video from corner sides
    height: 100%;
  }

  .vjs-control-bar {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: rgba(43, 51, 63, 0.7);
  }
}
</style>
